import styled from 'styled-components'

export const technic = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  border-radius: 16px;
  padding: 0 16px;
  background: transparent;
  color: var(--dark);
  border: 2px solid var(--dark);
`
export const ThemeButton = styled.button`
  display: none;
  position: fixed;
  left: 0px;
  bottom: 0px;
  z-index: 0;
  width: 40px;
  height: 40px;
  padding: 10px;
  opacity: 0.5;
  border: none;
  div {
    transform-origin: center left;
    transform: rotate(30deg);
    position: absolute;
    top: 10px;
    left: 20px;
    width: 10px;
    height: 20px;
    overflow: hidden;
    &:before {
      display: block;
      position: absolute;
      left: -10px;
      content: '';
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: var(--dark);
      border: 1px solid var(--light);
    }
  }
  &:before {
    content: '';
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--light);
    border: 1px solid var(--dark);
  }
  &:hover {
    opacity: 1;
    background: transparent;
  }
`
